<template>
  <div class="prizeset">
    <el-dialog title="奖励设置" :visible.sync="dialogFormVisible" width="950px" :close-on-click-modal="false" @close="close">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="每日完成订单奖励" required="true" prop="dayType">
          <el-radio v-model="form.dayType" label="1">全职</el-radio>
          <el-radio v-model="form.dayType" label="2">兼职</el-radio>
          <div class="flex numberip mar_b10" v-for="(item, index) in form.everyday" :key="index">
            <div class>每日完成单区间（单）</div>
            <el-input-number v-model="item.startNum" controls-position="right" :min="0" :max="99999999" class></el-input-number>
            <div class="mar_lr10">~</div>
            <el-input-number v-model="item.endNum" controls-position="right" :min="0" :max="99999999" class></el-input-number>
            <div class="mar_lr10">奖励金额</div>
            <el-input-number v-model="item.money" controls-position="right" :min="0" :max="99999999" class></el-input-number>
            <div class="mar_lr10">元</div>
            <el-button size="mini" type="text" @click="delSpecMethod(index)" class="mar_l20">删除</el-button>
          </div>
          <el-button type="text" class @click="addSpecMethod" v-show="form.everyday.length < 3">添加每日完成单区间</el-button>
        </el-form-item>
        <el-form-item label="时段完成订单奖励" prop="timeType" :required="true">
          <el-radio v-model="form.timeType" label="1">全职</el-radio>
          <el-radio v-model="form.timeType" label="2">兼职</el-radio>
          <div v-for="(item, index) in form.time" :key="index">
            <div class="flex numberip">
              <div>选择时间段</div>
              <el-time-select placeholder="起始时间" v-model="item.startAt" :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30'
                }" class="mar_l10"></el-time-select>
              <el-time-select placeholder="结束时间" v-model="item.endAt" class="mar_l10" :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30',
                  minTime: item.startAt
                }"></el-time-select>
            </div>
            <div class="flex numberip mar_t10 mar_b20">
              <div class>每日完成单区间（单）</div>
              <el-input-number v-model="item.startNum" controls-position="right" :min="0" :max="99999999" class></el-input-number>
              <div class="mar_lr10">~</div>
              <el-input-number v-model="item.endNum" controls-position="right" :min="0" :max="99999999" class></el-input-number>
              <div class="mar_lr10">奖励金额</div>
              <el-input-number v-model="item.money" controls-position="right" :min="0" :max="99999999" class></el-input-number>
              <div class="mar_lr10">元</div>
              <el-button size="mini" type="text" @click="delSpecMethod2(index)" class="mar_l20">删除</el-button>
            </div>
          </div>
          <el-button type="text" class @click="addSpecMethod2" v-show="form.time.length < 3">添加时间段</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getConfig, postConfig } from '@/api/set';
export default {
  name: 'labelSave',
  created() {},
  data() {
    return {
      form: {
        dayType: '',
        everyday: [
          {
            startNum: '',
            endNum: '',
            money: ''
          }
        ],
        timeType: '',
        time: [
          {
            startAt: '',
            endAt: '',
            startNum: '',
            endNum: '',
            money: ''
          }
        ]
      },

      dialogFormVisible: false
    };
  },
  components: {},
  methods: {
    showEdit() {
      this.dialogFormVisible = true;
      this.init();
    },
    close() {
      this.$refs['form'].resetFields();
      this.form = this.$options.data().form;
      this.dialogFormVisible = false;
    },
    addSpecMethod() {
      let specObj = {
        startNum: '',
        endNum: '',
        money: ''
      };
      this.$set(this.form.everyday, this.form.everyday.length, specObj);
    },
    addSpecMethod2() {
      let specObj = {
        startAt: '',
        endAt: '',
        startNum: '',
        endNum: '',
        money: ''
      };
      this.$set(this.form.time, this.form.time.length, specObj);
    },
    delSpecMethod(index) {
      this.$delete(this.form.everyday, index);
    },
    delSpecMethod2(index) {
      this.$delete(this.form.time, index);
    },
    async init() {
      const { data } = await getConfig({ ident: 'reward' });
      this.form2 = this.form;
      this.form = Object.assign(this.form2, data);
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.form.ident = 'reward';
          const { msg } = await postConfig(this.form);
          this.$baseMessage(msg, 'success');
          this.$emit('fetchData');
          this.close();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.prizeset {
  .time_item .el-input {
    width: 180px;
  }
  .numberip .el-input {
    width: 120px !important;
  }
  .numberip .el-input-number {
    width: 120px;
  }
}
</style>
